import { extendObservable } from 'mobx';

class LoginModel {
    constructor() {
        extendObservable(this, {
            username: '',
            password: ''
        });
    }

    validate(name) {
        return true;
    }
}

export default LoginModel;



// WEBPACK FOOTER //
// ./src/models/LoginModel.js